import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DealerActions } from 'src/app/common/store/actions/dealer.actions';

import { selectAllCarImagesFolders, selectDealerFetchingResults, selectCustomerCarsByBusinessLine } from 'src/app/common/store/state/app.state';
import { Car } from 'src/app/public/car/models/car.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { TransactionStage, TransactionRole } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { BookingStatus } from 'src/app/public/rent/constants/rent-basic-data';
import { BookingDialogComponent } from 'src/app/public/rent/elements/booking-dialog/booking-dialog.component';
import { Booking } from 'src/app/public/rent/models/booking.model';


@Component({
    selector: 'app-customer-rent',
    templateUrl: './customer-rent.component.html',
    styleUrls: ['./customer-rent.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CustomerRentComponent implements OnInit {

  BookingStatus = BookingStatus;
  
  myRentCars$: Observable<Car[]>;
  myRentCars: Car[] = [];

  carImagesFolders$: Observable<Map<string, Array<FileData>>>;
  
  businessLine: CarBusinessLine = CarBusinessLine.RENT;
  objectSource: ObjectSource = ObjectSource.RENT
  transactionStages: TransactionStage[] = [TransactionStage.ONGOING];
  transactionRole: TransactionRole = TransactionRole.CUSTOMER

  fetchingResults$: Observable<boolean>;

  TransactionStage = TransactionStage

  constructor(
    private store: Store, 
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog
    ) {

      this.fetchingResults$ = store.select(selectDealerFetchingResults);
      
      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
      this.myRentCars$ = store.select(selectCustomerCarsByBusinessLine(this.businessLine));
    }

    ngOnInit() {

        this.myRentCars$.subscribe(
          (res: Car[]) =>  {
            this.myRentCars = res!.map(c => Object.assign(new Car(), c));
          }
        );

        this.route.data.subscribe(
          data => {
            this.transactionStages = data['transactionStages'];
            this.store.dispatch(DealerActions.providerOffersFetchMySubmit({ transactionRole: this.transactionRole, businessLine: this.businessLine, transactionStages: this.transactionStages}));
          }
        )
        //this.store.dispatch(DealerActions.fetchCustomerCarsSubmit({businessLine: this.businessLine, favoritesOnly: false}));
  }

  openBookingDialog(carId: string, bookingId: number): void {
      
        let objectData: ObjectData = new ObjectData(this.objectSource, carId, bookingId );
    
        const dialogRef = this.dialog.open(BookingDialogComponent, {
          data: objectData
        });
      }
  
    canNewBooking(bookings: Booking[]): boolean{
        let index = bookings.findIndex(p => p.status !== BookingStatus.CANCELLED)
        return index === -1;
      }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }
}

